import { getFirstAndLastDayMonth } from "@/services/Utils";

const { first, last } = getFirstAndLastDayMonth();

export const base_filter = [
	{
		key: "integration_id",
		label: "Integración",
		type: "select",
		multiple: true,
		value: "",
		visible: true,
		placeholder: "Selecciona...",
		options: [],
	},
	{ key: "balance_id", label: "Balanza", type: "select", multiple: true, value: "", visible: true, placeholder: "Selecciona...", options: [] },
	{ key: "code", label: "Código", type: "text", value: "", visible: true, placeholder: "Código" },
	{ key: "body_send", label: "Buscar en datos enviados", type: "text", value: "", visible: true, placeholder: "Buscar en datos enviados..." },
	{ key: "response", label: "Buscar en respuesta", type: "text", value: "", visible: true, placeholder: "Buscar en respuesta..." },
	{ key: "date_from", label: "Fecha desde", type: "date", value: first, visible: true, placeholder: "Fecha desde" },
	{ key: "date_to", label: "Fecha hasta", type: "date", value: last, visible: true, placeholder: "Fecha hasta" },
	{
		key: "completed",
		label: "Estado",
		type: "select",
		multiple: false,
		value: "",
		visible: true,
		placeholder: "Selecciona...",
		options: [
			{ label: "Completada", value: "true" },
			{ label: "Pendiente", value: "false" },
		],
	},
];
